<template>
    <div id="Dashboard">
        <q-dialog persistent position="right" v-model="dialog">
            <CreatePartner @closeCreatePartnerDialog="dialog=false"></CreatePartner>
        </q-dialog>
        <div class="row q-pa-md pb-3">
            <div class="w-100 d-flex justify-content-between" style="align-items: center;margin-top: 5px">
                <h3 class="" style="font-size: 22px; font-weight: 300; margin-left: 16px; text-transform: capitalize"
                    v-if="loggedIn_partnerType === Constants.RD||loggedIn_partnerType === Constants.VAD">Partners</h3>
                <!-- RD loggedIn -->
                <div class="ml-auto position-absolute d-flex search-table" style="right: 0px" v-if="loggedIn_partnerType!==Constants.RP">
                    <div @click="refreshScreen" class="export-button mr-3" style="height: 40px; width: 40px;">
                        <div>
                            <img alt="" src="../assets/reload-white.png">
                        </div>
                    </div>
                    <div @click="dialog=true" class="addButton-2 d-flex" style="height: 40px;">
                        <div class=" mx-auto my-auto">Add Partner</div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-12 q-pa-md dash-slider">
            <q-carousel animated autoplay control-color="black" height="auto"
                        infinite navigation swipeable transition-next="slide-left" transition-prev="slide-right"
                        v-model="slide"
                        value="">
                <q-carousel-slide style="max-height: 700px" :key="index" :name="index" @click="openImageUrl(img)"
                                  v-for="(img,index) in galleryImages">
                    <img :src="'https://thumbor.avinashi.com/unsafe/'+img.imageUrl" class="w-100">
                </q-carousel-slide>
            </q-carousel>
        </div>

            <div class="d-flex q-pa-md pt-0">
                <div @click="gotoPartnerScreen('vad')" class="vad-dashboard ml-3" v-if="loggedIn_partnerType === Constants.RD">
                    <div class="container d-flex " style="align-items: center">
                        <h2 class="heading p-3 m-0" style="color: #2d2d2d">{{count.vad}}</h2>
                        <h4 class="ml-4" style="color: #2d2d2d">Value Added Distributor</h4>
                    </div>
                </div>
                 <!-- chelsi -->
                <div @click="gotoPartnerScreen('vp')" class="vp-dashboard  ml-3"
                     v-if="loggedIn_partnerType === Constants.RD||loggedIn_partnerType === Constants.VAD">
                    <div class="container  d-flex" style="align-items: center">
                        <h2 class="heading p-3 m-0" style="color: #e74ba8">{{count.vp}}</h2>
                        <h4 class="ml-4" style="color: #e74ba8;">Volume Partner</h4>
                    </div>
                </div>
                <div @click="gotoPartnerScreen('vap')" class="vap-dashboard  ml-3"
                     v-if="loggedIn_partnerType === Constants.RD||loggedIn_partnerType === Constants.VAD||loggedIn_partnerType === Constants.VP">
                    <div class="container  d-flex" style="align-items: center">
                        <h2 class="heading p-3 m-0" style="color: #2d2d2d">{{count.vap}}</h2>
                        <h4 class="ml-4" style="color: #2d2d2d">Value Added Partner</h4>
                    </div>
                </div>
               
                <div @click="gotoPartnerScreen('rp')" class="rp-dashboard  ml-3"
                     v-if="loggedIn_partnerType === Constants.RD||loggedIn_partnerType === Constants.VAD||loggedIn_partnerType === Constants.VP">
                    <div class="container  d-flex" style="align-items: center">
                        <h2 class="heading p-3 m-0" style="color: #2d2d2d">{{count.rp}}</h2>
                        <h4 class="ml-4" style="color: #2d2d2d">Retail Partner</h4>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>
  import { GET_ALL_ORGANIZATIONS_COUNT } from '../graphql/queries/organization'
  import { SUBSCRIBE_ALL_ORGANIZATIONS_COUNT } from '../graphql/subscription/organization'
  import { GET_ALL_APPLICATIONS } from '../graphql/queries/application'
  import { SUBSCRIBE_ALL_APPLICATIONS } from '../graphql/subscription/application'
  import { GET_GALLERY } from '../graphql/queries/Gallery'
  import CreatePartner from './CreatePartner'
  import Constants from '../Constants/Constant'

  export default {
    name: 'Dashboard',
    components: { CreatePartner },
    apollo: {
      Organizations: {
        query: GET_ALL_ORGANIZATIONS_COUNT,
        fetchPolicy:'network-only',
        skip: JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.VAP ||
              JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.RP ,
              // JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.VP ,
        variables: {
            // partnerType: not in VAD, RD and NP(for VAD loggedIn) & not in RD and NP(for RD loggedIn)
            prefferedVP: JSON.parse(localStorage.getItem('user')).orgId,
            partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType ===
            '3260ebcf-8944-4dc1-a003-9997b0e07811' ?
                [
                    '3260ebcf-8944-4dc1-a003-9997b0e07811',
                    '917370fd-9532-4f84-bd30-9b6f0777e206',
                    // '967c4293-e850-4191-9997-75fb37cce656',
                    '9260ebcf-8944-4dc1-a003-9997b0e07811'] :
                ['917370fd-9532-4f84-bd30-9b6f0777e206', '9260ebcf-8944-4dc1-a003-9997b0e07811'],
        },
        subscribeToMore: {
          document: SUBSCRIBE_ALL_ORGANIZATIONS_COUNT,
          skip: JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.VAP ||
                JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.RP ,
                //  JSON.parse(localStorage.getItem('user')).organization.partnerType === Constants.VP ,
          variables: {
              // partnerType: not in VAD, RD and NP(for VAD loggedIn) & not in RD and NP(for RD loggedIn)
              prefferedVP: JSON.parse(localStorage.getItem('user')).orgId,
              partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType ===
              '3260ebcf-8944-4dc1-a003-9997b0e07811' ?
                  [
                      '3260ebcf-8944-4dc1-a003-9997b0e07811',
                      '917370fd-9532-4f84-bd30-9b6f0777e206',
                      // '967c4293-e850-4191-9997-75fb37cce656',
                      '9260ebcf-8944-4dc1-a003-9997b0e07811'] :
                  ['917370fd-9532-4f84-bd30-9b6f0777e206', '9260ebcf-8944-4dc1-a003-9997b0e07811'],
          },
          updateQuery: function (previousQueryResult, { subscriptionData }) {
            this.separateOrganizationOnType(subscriptionData.data.Organizations)
          },
        },
        result ({ data, loading }) {
          if (!loading) {
            this.separateOrganizationOnType(data.Organizations)
          }
        },
      },
      Applications: {
        query: GET_ALL_APPLICATIONS,
        fetchPolicy:'network-only',
        subscribeToMore: {
          document: SUBSCRIBE_ALL_APPLICATIONS,
          updateQuery: function (previousQueryResult, { subscriptionData }) {
            this.allApp = subscriptionData.data.Applications
            this.extractStages()
          },
        }, result ({ data, loading }) {
          if (!loading) {
            this.allApp = data.Applications
            this.extractStages()
          }
        },
      },
    },
    data () {
      let self = this
      return {
        Constants: Constants,
        dialog: false,
        loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
        allApp: [],
        newApp: [],
        approvedApp: [],
        rejectedApp: [],
        slide: 0,
        count: { vad: 0, vap: 0, rp: 0 , vp:0, },
        galleryImages: [],
      }
    },
    mounted () {
      this.getGallery()
    },
    methods: {
      refreshScreen () {
        if (this.loggedIn_partnerType === '917370fd-9532-4f84-bd30-9b6f0777e206') {
          this.$apollo.queries.Organizations.refetch()
        }
      },
      openImageUrl (obj) {
        if (obj.redirectUrl)
          window.open(obj.redirectUrl, '_blank')
      },
      extractStages () {
        let self = this
        this.approvedApp = []
        this.newApp = []
        this.rejectedApp = []
        if (this.allApp) {
          this.allApp.forEach(function (ap) {
            if (ap.stageId === '245eeacc-ceb2-4108-b281-1ce86a12cf02')
              self.approvedApp.push(ap)
            else if (ap.stageId === 'b95d8bc8-1aa8-4acb-8c44-ed4940148155')
              self.newApp.push(ap)
            else if (ap.stageId === '6cf4590a-cc2c-49a7-95df-a25e0d5972c0')
              self.rejectedApp.push(ap)
          })
        }
      },
      async getGallery () {
        let response = await this.$apollo.query({
          query: GET_GALLERY,
          fetchPolicy:'network-only',
          variables: {
            partnerType: this.loggedIn_partnerType,
          },
        })
        this.galleryImages = response.data.Gallery
      },
      separateOrganizationOnType (data) {
        let self = this
        this.count.vad = 0
        this.count.vap = 0
        this.count.vp = 0
        this.count.rp = 0
        data.forEach(app => {
          if (app.partnerType === Constants.VAP)
            self.count.vap++
          else if (app.partnerType === Constants.RP)
            self.count.rp++
            else if (app.partnerType === Constants.VP)
            self.count.vp++
          else if (app.partnerType === Constants.VAD)
            self.count.vad++
        })
      },
      gotoPartnerScreen (where) {
        this.$router.push({ path: 'Partners', query: { where: where } }).catch(()=>{})
      },
      gotoCardScreen (where) {
        this.$router.push({ path: '/Partners/Applications', query: { where: where } }).catch(()=>{})
      },
    },
  }
</script>
<style lang="stylus" scoped>
    #Dashboard
        /*background #eff5f4*/
        /*height 89vh*/

        .vad-dashboard, .vp-dashboard ,.vap-dashboard, .rp-dashboard{
            width: 49%;
            /*border-radius 5px*/
            /*border: 1px solid #008793;*/
            border-radius 5px
            transition 0.3s
            background #5855d4
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2)

            h4 {
                color #fff !important
            }

            .heading {
                color: #fff !important
            }
        }

        .vap-dashboard {
            background #ff9319
        }
        .vp-dashboard {
            background #cb2e2e
        }
        .rp-dashboard {
            background #827717
        }

        .vad-dashboard:hover,.vp-dashboard:hover, .vap-dashboard:hover, .rp-dashboard:hover {
            background: rgba(0, 135, 147, 0.07)
            cursor: pointer

            h4 {
                color #2d2d2d !important
            }

            .heading {
                color: #2d2d2d !important
            }
        }

        .card
            -webkit-touch-callout: none
            -webkit-user-select: none
            -khtml-user-select: none;
            -moz-user-select: none
            -ms-user-select: none
            user-select: none;
            background: #1fd2b4;

            display inline-block
            margin 1%
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2)
            transition: 0.3s
            border-radius: 5px
            width 23%
            text-align center
            max-width 250

        .card:hover
            cursor pointer
            background #ffffff
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);


        .container
            font-weight bolder !important
            color #2D2D2D
            text-transform uppercase
            padding: 2px 16px;


        .container h4
            font-size 17px
            transition all 0.3s
            line-height 80px;
            color: #fff


        .container .heading
            font-family: avenirRegular;
            transition all 0.3s
            line-height 80px
            margin-top: 15px
            color: #fff


        .card:hover .container .heading
            color #2D2D2D

        .card:hover .container h4
            color #2D2D2D

    .custom-caption
        text-align center
        padding 12px
        color white
        background-color rgba(0, 0, 0, .3)
</style>
<style scoped>
    /deep/ .q-carousel__navigation-inner {
        justify-content: center !important;
        padding-bottom: 10px;
    }
</style>
